import PaginaNaoEncontrada from "./PaginaNaoEncontrada";
export default PaginaNaoEncontrada;